import type { IAddress } from "@bbj-types/address";
import type { IAddressOptions } from "./logics";

export const formatDefaultValue = (userFavoritesAddresses: IAddress[] | undefined): IAddressOptions[] | undefined => {
  if (!userFavoritesAddresses) {
    return undefined;
  }
  const addresses = userFavoritesAddresses.map((address) => ({
    ...address,
    isFavorite: true,
  }));
  return addresses;
};
